module.exports = __webpack_public_path__ + "static/media/matching.c71e9479.png";